import React from "react";

import { Box } from "@mui/material";
import Nav_bar from "../nav_bar";
import { Navigate } from "react-router-dom";
import DataFilter from "./DataFilter";
import DataTabs from "./DataTabs";
import { AppProvider } from "../../context/AppContext";
const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user.auth) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <Nav_bar />
      <Box p={2}>
        <AppProvider>
          <DataTabs />
        </AppProvider>
      </Box>
    </>
  );
};

export default Dashboard;
